import React from "react";
import { Button } from "./Button";

interface EditSectionButtonProps {
  onClick: () => void;
  className?: string;
}

/**
 * Reusable edit button component with pencil icon
 */
const EditSectionButton: React.FC<EditSectionButtonProps> = ({
  onClick,
  className = "",
}) => {
  return (
    <Button
      size="sm"
      variant="outline"
      onClick={onClick}
      className={`bg-white bg-opacity-70 hover:bg-opacity-100 ${className}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
        />
      </svg>
      <span className="ml-1">Edit</span>
    </Button>
  );
};

export default EditSectionButton;
